export class FiltroListagemContrato {

    numero_contrato: string = undefined;
    numero_licitacao: string = undefined;
    objeto_licitacao: string = undefined;
    orgao: string = undefined;
    isCovid19: boolean = undefined;
}



// WEBPACK FOOTER //
// ./src/app/components/contrato/contrato-by-numerocontrato/dto/filtroListagemContrato.ts